import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import { Button, Form, Modal, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import GoBackButton from "../layout/GoBackButton";
import { getFirm } from "../../actions/firms";
import { toast } from 'react-toastify';
import axios from 'axios';
import getApiUrl from '../../config/api';

const FirmPage = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { firm, loading } = useSelector(state => state.firm);

    // Working days management state
    const [showWorkingDaysModal, setShowWorkingDaysModal] = useState(false);
    const [workingDaysForm, setWorkingDaysForm] = useState({
        working_days_per_month: ''
    });
    const [workingDaysLoading, setWorkingDaysLoading] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        if (id) {
            dispatch(getFirm(id));
        }
    }, [dispatch, id]);

    // Update form when firm data loads
    useEffect(() => {
        if (firm) {
            setWorkingDaysForm({
                working_days_per_month: firm.working_days_per_month || 26
            });
        }
    }, [firm]);

    const handleWorkingDaysSubmit = async (e) => {
        e.preventDefault();
        setFormErrors({});

        if (!workingDaysForm.working_days_per_month || workingDaysForm.working_days_per_month < 1 || workingDaysForm.working_days_per_month > 31) {
            setFormErrors({ working_days_per_month: 'Ish kunlari 1 dan 31 gacha bo\'lishi kerak' });
            return;
        }

        setWorkingDaysLoading(true);
        try {
            const response = await axios.put(`${getApiUrl()}/firm-working-days/${id}`, {
                working_days_per_month: parseInt(workingDaysForm.working_days_per_month)
            }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });

            if (response.data.success) {
                toast.success('Oylik ish kunlari muvaffaqiyatli yangilandi');
                setShowWorkingDaysModal(false);
                // Refresh firm data
                dispatch(getFirm(id));
            }
        } catch (error) {
            console.error('Error updating working days:', error);
            if (error.response?.data?.errors) {
                setFormErrors(error.response.data.errors);
            } else {
                toast.error('Ish kunlarini yangilashda xatolik');
            }
        } finally {
            setWorkingDaysLoading(false);
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!firm) {
        return <div>Firm not found</div>;
    }

    return (
        <div>
            <main className="content mt-0 pt-0">
                <div className="container-fluid p-0">

                    <div className="row mb-2">
                        <div className="col-md-12 col-lg-8">
                            <h1 className="h3 mb-3"><strong>Firma</strong> ma'lumotlari: </h1>
                        </div>
                        <div className="col-lg-4">
                            <div className="crud_actions text-end">
                                <GoBackButton />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="card">
                                <div className="card-body text-center">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="d-flex align-items-center">
                                                <div className="card-title m-2">Firma nomi:</div>
                                                <div className="text-muted m-0">{firm?.name}</div>
                                            </div>

                                            <div className="d-flex">
                                                <div className="card-title m-2">Manzili:</div>
                                                <div className="text-muted text-start m-2">{firm?.address}</div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="card-title m-2">Telefon:</div>
                                                <div className="text-muted text-start m-2">{firm?.phone}</div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="card-title m-2">MFO:</div>
                                                <div className="text-muted text-start m-2">{firm?.mfo}</div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="card-title m-2">INN:</div>
                                                <div className="text-muted text-start m-2">{firm?.inn}</div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="card-title m-2">Bank hisob(р.сч):</div>
                                                <div className="text-muted text-start m-2">{firm?.bank_account}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Working Days Section */}
                                <div className="card-header border-top">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5 className="card-title mb-0">Ish kunlari sozlamalari</h5>
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={() => setShowWorkingDaysModal(true)}
                                        >
                                            <FontAwesomeIcon icon={faEdit} className="me-1" />
                                            Tahrirlash
                                        </Button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="d-flex align-items-center">
                                                <FontAwesomeIcon icon={faCalendarAlt} className="me-2 text-primary" />
                                                <div className="card-title m-2">Oylik ish kunlari:</div>
                                                <div className="text-muted m-0">
                                                    <strong className="text-success fs-5">
                                                        {firm?.working_days_per_month || 26} kun
                                                    </strong>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <small className="text-muted">
                                                Bu sozlama xodimlarning kunlik ish haqini hisoblash uchun ishlatiladi
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-header border-top">
                                    <h5 className="card-title mb-0">Firma boshqaruvchisi:</h5>
                                </div>
                                <div className="card-body text-center">
                                    <div className="row">
                                        <div className="col-md-12 ms-2">
                                            <div className="d-flex align-items-center">
                                                <div className="card-title m-2">Ismi:</div>
                                                <div className="text-muted m-0">{firm?.manager?.name}</div>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <div className="card-title m-2">Email:</div>
                                                <div className="text-muted m-0">{firm?.manager?.email}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 col-lg-8">
                            <h4 className="h4 mb-3"> skladlar </h4>
                        </div>

                        <div className="col-lg-12 col-md-12">
                            <div className="card">
                                <div className="card-body p-0 w-100 table-responsive">
                                    <table className="table custom-table table-hover">
                                        <thead className="table-light">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Nomi</th>
                                            <th scope="col">Skladchi</th>
                                            <th scope="col">Sklad turi</th>
                                        </tr>
                                        </thead>

                                        <tbody className="p-0 m-0">
                                        {
                                            firm?.warehouses?.map((item, index) => (
                                                <tr key={`warehouse${index}`}>
                                                    <th scope="row">{index + 1}</th>
                                                    <td>{item.name}</td>
                                                    <td>{item.storekeeper?.name}</td>
                                                    <td>{item.type}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 col-lg-8">
                            <h4 className="h4 mb-3"> xodimlar </h4>
                        </div>

                        <div className="col-lg-12 col-md-12">
                            <div className="card">
                                <div className="card-body p-0 w-100 table-responsive">
                                    <table className="table custom-table table-hover">
                                        <thead className="table-light">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Ism</th>
                                            <th scope="col">Familiya</th>
                                            <th scope="col">INN</th>
                                            <th scope="col">Manzil</th>
                                            <th scope="col">Telefon</th>
                                            <th scope="col">Kasbi</th>
                                            <th scope="col">Holati</th>
                                        </tr>
                                        </thead>

                                        <tbody className="p-0 m-0">
                                        {
                                            firm?.employees?.map((item, index) => (
                                                <tr key={`employee${index}`}>
                                                    <th scope="row">{index + 1} </th>
                                                    <td>{item.first_name}</td>
                                                    <td>{item.last_name}</td>
                                                    <td>{item.inn}</td>
                                                    <td>{item.address}</td>
                                                    <td>{item.phone}</td>
                                                    <td>{item.profession}</td>
                                                    <td>{item?.status === 'hired' ? 'Faol' : 'Ishlamayapti'}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Working Days Update Modal */}
            <Modal show={showWorkingDaysModal} onHide={() => setShowWorkingDaysModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Oylik ish kunlarini tahrirlash</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleWorkingDaysSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Oylik ish kunlari soni *</Form.Label>
                            <Form.Control
                                type="number"
                                min="1"
                                max="31"
                                value={workingDaysForm.working_days_per_month}
                                onChange={(e) => setWorkingDaysForm({
                                    working_days_per_month: e.target.value
                                })}
                                className={formErrors.working_days_per_month ? 'is-invalid' : ''}
                                placeholder="26"
                            />
                            {formErrors.working_days_per_month && (
                                <div className="invalid-feedback">
                                    {formErrors.working_days_per_month}
                                </div>
                            )}
                            <Form.Text className="text-muted">
                                Standart qiymat: 26 kun. Bu xodimlarning kunlik ish haqini hisoblash uchun ishlatiladi.
                            </Form.Text>
                        </Form.Group>

                        <Alert variant="info">
                            <strong>Hozirgi qiymat:</strong> {firm?.working_days_per_month || 26} kun/oy
                            <br />
                            <small>
                                Kunlik ish haqi = Oylik bazaviy ish haqi ÷ {firm?.working_days_per_month || 26} kun
                            </small>
                        </Alert>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowWorkingDaysModal(false)}>
                            Bekor qilish
                        </Button>
                        <Button variant="primary" type="submit" disabled={workingDaysLoading}>
                            {workingDaysLoading ? 'Saqlanmoqda...' : 'Saqlash'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
};

export default FirmPage;